import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  EditSaveHandler,
  isPageEditFalse,
} from "../CommonComponent/EditSaveHandler";
import {
  SubmitApprovalRequestAction,
  ViewRequestStatusAction,
} from "../../../redux/actions/GlobalAction";
import {
  addStaffDetails,
  getAllStaffDetails,
} from "../../../redux/actions/StaffDetailsAction";
import { MandatoryStar } from "../../../Utils/helper";
import { DeleteNetworkRowPopup } from "./DeleteNetworkRowPopup";
import { DeleteOperationRowPopup } from "./DeleteOperationRowPopup";
import ROUTES from "../../../Utils/routesConstants";
import { addProviderAssitLogAction } from "../../../redux/actions/ProviderAssistAction";
import {
  getCampaignsToken,
  getNetworkMenuId,
  getProviderPortalId,
  getRole,
} from "../../../Utils/types.js";
import { useLocation, useParams } from "react-router-dom";

const StaffDetails = () => {
  const urlParams = useParams();
  const location = useLocation();
  let source = location?.search.split("=")[1];
  localStorage.setItem("campaignsToken", urlParams?.token);
  const dispatch = useDispatch();
  const [networksEmployees, setNetworksEmployees] = useState(null);
  const [operationsEmployees, setOperationsEmployees] = useState(null);
  const [operationIndex, setOperationIndex] = useState(null);
  const [networkIndex, setNetworkIndex] = useState(null);
  useEffect(() => {
    dispatch(getAllStaffDetails());
  }, []);

  const getStaffDetails = useSelector(
    (state) => state?.StaffDetailsReducer?.getStaffDetails
  );

  const isPageEdit = useSelector((state) => state?.globalReducer?.isPageEdit);

  useEffect(() => {
    if (getStaffDetails) {
      setNetworksEmployees(getStaffDetails?.networksEmployees);
      setOperationsEmployees(getStaffDetails?.operationsEmployees);
    }
  }, [getStaffDetails]);

  const networksEmployeesChangeHandler = (id, name, value) => {
    let updatedTodos = networksEmployees?.map((ele, index) => {
      if (index === id) {
        ele[name] = value;
      }
      return ele;
    });
    setNetworksEmployees(updatedTodos);
  };

  const operationsEmployeesHandler = (id, name, value) => {
    let updatedTodos = operationsEmployees?.map((ele, index) => {
      if (index === id) {
        ele[name] = value;
      }
      return ele;
    });
    setOperationsEmployees(updatedTodos);
  };

  const handleAddFieldsNetwork = () => {
    setNetworksEmployees([
      ...networksEmployees,
      {
        employeeId: networksEmployees?.[0]?.employeeId,
        subdivision: "Other",
        designation: "",
        employeeName: "",
        primaryContactNumber: "",
        alternativeContactNumber: "",
        emailAddress: "",
      },
    ]);
  };

  const handleAddFieldsOperation = () => {
    setOperationsEmployees([
      ...operationsEmployees,
      {
        employeeId: operationsEmployees?.[0]?.employeeId,
        subdivision: "Other",
        designation: "",
        employeeName: "",
        primaryContactNumber: "",
        alternativeContactNumber: "",
        emailAddress: "",
      },
    ]);
  };

  const SaveHandler = async (event) => {
    event.preventDefault();
    let temp;
    if (source === "WhatsApp" || source === "Email") {
      temp = {
        networksEmployees: networksEmployees,
        operationsEmployees: operationsEmployees,
        source: source,
      };
    } else {
      if (getRole() === "NetworkAdmin") {
        temp = {
          networksEmployees: networksEmployees,
          operationsEmployees: operationsEmployees,
          source: "Network",
        };
      } else {
        temp = {
          networksEmployees: networksEmployees,
          operationsEmployees: operationsEmployees,
        };
      }
    }
    await dispatch(addStaffDetails(temp));
    await dispatch(getAllStaffDetails());
    await isPageEditFalse(dispatch);
    await dispatch(ViewRequestStatusAction("StaffDetail"));
    window.location.pathname.includes(ROUTES.PROVIDER_ASSIST) &&
      (await dispatch(
        addProviderAssitLogAction({
          providerId: getProviderPortalId(),
          moduleName: "StaffDetail",
          actionFlag: "E",
        })
      ));
  };

  return (
    <form onSubmit={SaveHandler}>
      <div className="right-section">
        <div className="card staff-details-section">
          <div className="card-body">
            <div className="staff-details-header d-flex justify-content-between align-items-center edit-save-css">
              <div>
                <h4>Staff Details</h4>
              </div>
              {((getNetworkMenuId()?.canEdit && getRole() === "NetworkAdmin") ||
                getRole() === "ServiceProvider" ||  getCampaignsToken() !== undefined) && (
                <EditSaveHandler
                  isShowViewButton={getStaffDetails?.isShowSubmitButton}
                  moduleName="StaffDetail"
                />
              )}
            </div>
            <div className="staff-table">
              <div className="d-flex justify-content-between">
                <h2>Network</h2>
                <div>
                  {isPageEdit && (
                    <button
                      className="btn add-row-btn"
                      type="button"
                      onClick={handleAddFieldsNetwork}
                    >
                      <i className="fa-solid fa-plus"></i>
                      Add Row
                    </button>
                  )}
                </div>
              </div>
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Contact Type</th>
                      <th>
                        Designation
                        <MandatoryStar />
                      </th>
                      <th>
                        Contact Person
                        <MandatoryStar />
                      </th>
                      <th>
                        Mobile Number
                        <MandatoryStar />
                      </th>
                      <th>Alternate Mobile Number</th>
                      <th>
                        Email ID
                        <MandatoryStar />
                      </th>
                      {isPageEdit && <th>Action</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {networksEmployees?.map((ele, index) => {
                      return (
                        <tr key={index}>
                          <th>{ele?.subdivision}</th>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              style={{ border: "none" }}
                              value={ele?.designation}
                              pattern=".*\S+.*"
                              onChange={(e) =>
                                networksEmployeesChangeHandler(
                                  index,
                                  "designation",
                                  e.target.value
                                )
                              }
                              disabled={!isPageEdit}
                              required
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              style={{ border: "none" }}
                              value={ele?.employeeName}
                              pattern=".*\S+.*"
                              onChange={(e) =>
                                networksEmployeesChangeHandler(
                                  index,
                                  "employeeName",
                                  e.target.value
                                )
                              }
                              onKeyPress={(e) => {
                                const re = /[a-zA-Z ]+/g;
                                if (!re.test(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              disabled={!isPageEdit}
                              required
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              minLength={10}
                              maxLength={10}
                              className="form-control"
                              style={{ border: "none" }}
                              value={ele?.primaryContactNumber}
                              onInvalid={(e) =>
                                e.target.setCustomValidity(
                                  "please enter a 10 digit mobile number"
                                )
                              }
                              onInput={(e) => e.target.setCustomValidity("")}
                              pattern="[0-9]+"
                              onChange={(e) =>
                                networksEmployeesChangeHandler(
                                  index,
                                  "primaryContactNumber",
                                  e.target.value
                                )
                              }
                              onKeyPress={(event) => {
                                const re = /[0-9]+/g;
                                if (!re.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              disabled={!isPageEdit}
                              required
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              minLength={8}
                              maxLength={15}
                              className="form-control"
                              style={{ border: "none" }}
                              value={ele?.alternativeContactNumber}
                              onChange={(e) =>
                                networksEmployeesChangeHandler(
                                  index,
                                  "alternativeContactNumber",
                                  e.target.value
                                )
                              }
                              onKeyPress={(event) => {
                                const re = /^[0-9\s\-]+$/;
                                if (!re.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              disabled={!isPageEdit}
                            />
                          </td>
                          <td>
                            <input
                              type="email"
                              className="form-control"
                              style={{ border: "none" }}
                              value={ele?.emailAddress}
                              pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{1,63}$"
                              onChange={(e) =>
                                networksEmployeesChangeHandler(
                                  index,
                                  "emailAddress",
                                  e.target.value
                                )
                              }
                              disabled={!isPageEdit}
                              required
                            />
                          </td>
                          {isPageEdit && (
                            <td>
                              {/* <button
                              className="btn btn-primary"
                              type="button"
                              onClick={() =>
                                setOperationsEmployees(
                                  operationsEmployees?.filter(
                                    (item, i) => i !== index
                                  )
                                )
                              }
                            >
                              Reset
                            </button> */}
                              &nbsp;&nbsp;
                              {ele?.subdivision === "Other" && (
                                <button
                                  className="btn btn-danger delete-btn"
                                  type="button"
                                  data-bs-toggle="modal"
                                  data-bs-target="#staticNetworkDeleteRow"
                                  onClick={() => setNetworkIndex(index)}
                                >
                                  <i className="fas fa-trash-alt"></i>
                                </button>
                              )}
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="staff-table">
              <div className="d-flex justify-content-between">
                <h2>Operations</h2>
                <div>
                  {isPageEdit && (
                    <button
                      className="btn add-row-btn"
                      type="button"
                      onClick={handleAddFieldsOperation}
                    >
                      <i className="fa-solid fa-plus"></i>
                      Add Row
                    </button>
                  )}
                </div>
              </div>
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Contact Type</th>
                      <th>
                        Designation
                        <MandatoryStar />
                      </th>
                      <th>
                        Contact Person
                        <MandatoryStar />
                      </th>
                      <th>
                        Mobile Number
                        <MandatoryStar />
                      </th>
                      <th>Alternate Mobile Number</th>
                      <th>
                        Email ID
                        <MandatoryStar />
                      </th>
                      {isPageEdit && <th>Action</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {operationsEmployees?.map((ele, index) => {
                      return (
                        <tr key={index}>
                          <th>{ele?.subdivision}</th>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              style={{ border: "none" }}
                              pattern=".*\S+.*"
                              value={ele?.designation}
                              onChange={(e) =>
                                operationsEmployeesHandler(
                                  index,
                                  "designation",
                                  e.target.value
                                )
                              }
                              disabled={!isPageEdit}
                              required
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              style={{ border: "none" }}
                              value={ele?.employeeName}
                              pattern=".*\S+.*"
                              onChange={(e) =>
                                operationsEmployeesHandler(
                                  index,
                                  "employeeName",
                                  e.target.value
                                )
                              }
                              onKeyPress={(e) => {
                                const re = /[a-zA-Z ]+/g;
                                if (!re.test(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              disabled={!isPageEdit}
                              required
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              minLength={10}
                              maxLength={10}
                              className="form-control"
                              style={{ border: "none" }}
                              value={ele?.primaryContactNumber}
                              pattern="[0-9]+"
                              onInvalid={(e) =>
                                e.target.setCustomValidity(
                                  "please enter a 10 digit mobile number"
                                )
                              }
                              onInput={(e) => e.target.setCustomValidity("")}
                              onChange={(e) =>
                                operationsEmployeesHandler(
                                  index,
                                  "primaryContactNumber",
                                  e.target.value
                                )
                              }
                              onKeyPress={(event) => {
                                const re = /[0-9]+/g;
                                if (!re.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              disabled={!isPageEdit}
                              required
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              minLength={8}
                              maxLength={15}
                              className="form-control"
                              style={{ border: "none" }}
                              value={ele?.alternativeContactNumber}
                              onChange={(e) =>
                                operationsEmployeesHandler(
                                  index,
                                  "alternativeContactNumber",
                                  e.target.value
                                )
                              }
                              onKeyPress={(event) => {
                                const re = /^[0-9\s\-]+$/;
                                if (!re.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              disabled={!isPageEdit}
                            />
                          </td>
                          <td>
                            <input
                              type="email"
                              className="form-control"
                              pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{1,63}$"
                              style={{ border: "none" }}
                              value={ele?.emailAddress}
                              onChange={(e) =>
                                operationsEmployeesHandler(
                                  index,
                                  "emailAddress",
                                  e.target.value
                                )
                              }
                              disabled={!isPageEdit}
                              required
                            />
                          </td>
                          {isPageEdit && (
                            <td>
                              {ele?.subdivision === "Other" && (
                                <button
                                  className="btn btn-danger delete-btn"
                                  type="button"
                                  data-bs-toggle="modal"
                                  data-bs-target="#staticOperationDeleteRow"
                                  onClick={() => setOperationIndex(index)}
                                >
                                  <i className="fas fa-trash-alt"></i>
                                </button>
                              )}
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            <DeleteOperationRowPopup
              operationIndex={operationIndex}
              operationsEmployees={operationsEmployees}
              setOperationsEmployees={setOperationsEmployees}
            />
            <DeleteNetworkRowPopup
              networkIndex={networkIndex}
              networksEmployees={networksEmployees}
              setNetworksEmployees={setNetworksEmployees}
            />
            <div className="mt-4 mb-2 text-end">
              {getStaffDetails?.isShowSubmitButton && !isPageEdit && (
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={async () => {
                    await dispatch(SubmitApprovalRequestAction("StaffDetail"));
                    await dispatch(getAllStaffDetails());
                    await dispatch(ViewRequestStatusAction("StaffDetail"));
                    window.location.pathname.includes(ROUTES.PROVIDER_ASSIST) &&
                      (await dispatch(
                        addProviderAssitLogAction({
                          providerId: getProviderPortalId(),
                          moduleName: "StaffDetail",
                          actionFlag: "S",
                        })
                      ));
                  }}
                >
                  SUBMIT
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default StaffDetails;
